import { render, staticRenderFns } from "./ExhibitionSale.vue?vue&type=template&id=cb11aafc&"
import script from "./ExhibitionSale.vue?vue&type=script&lang=js&"
export * from "./ExhibitionSale.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionSale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports